import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import RichText from '../controls/RichText';
import Dropdown from 'react-bootstrap/Dropdown';
import { TaskSlider } from '@bittnerdevelopmentgroup/interactive';
import NeutralToggle from '../controls/NeutralToggle';
import { useForceUpdate, isValidURL } from '../util';
import { FormValidityProvider, FormValidityReporter } from '../FormValidity';
function validateImage(imageLink) {
  var request = new XMLHttpRequest();
  request.open("GET", imageLink, false);
  request.send();
  return request.status === 200;
}
export default function ImageInfo(props) {
  var _dataProps$style, _dataProps$style2, _dataProps$style3, _dataProps$alignment;
  const forceUpdate = useForceUpdate();
  const parent = props;
  const dataProps = parent.data.props;
  if (dataProps.style === undefined) {
    dataProps.style = {
      width: "728px"
    };
  }
  const [hasCredits, setHasCredits] = useState(dataProps.photoCredit !== undefined);
  const [tempCredits, setTempCredits] = useState("");
  return /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChange
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Image URL:"), " ", /*#__PURE__*/React.createElement("i", null, "A direct link to the image.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.src,
    onChange: e => {
      dataProps.src = e.target.value;
      forceUpdate();
      parent.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: isValidURL(dataProps.src)
  }, "Please type in a valid URL."), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: validateImage(dataProps.src)
  }, "Image did not load properly.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Alt Text:"), " ", /*#__PURE__*/React.createElement("i", null, "A literal description of the image.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.alt,
    onChange: e => {
      dataProps.alt = e.target.value;
      forceUpdate();
      parent.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: dataProps.alt.length > 0
  }, "Images must have alt text."), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: dataProps.alt.length <= 140
  }, "Alt text should generally be less than 140 characters.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Long Alt Text:"), " ", /*#__PURE__*/React.createElement("i", null, "A longer description of the image (optional).")), /*#__PURE__*/React.createElement(RichText, {
    value: dataProps.longAlt,
    onChange: v => {
      dataProps.longAlt = v;
      forceUpdate();
      parent.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Width:"), " ", /*#__PURE__*/React.createElement("i", null, "The maximum width of the image, as a percentage.")), /*#__PURE__*/React.createElement(TaskSlider, {
    handleChange: value => {
      dataProps.style = dataProps.style || {};
      dataProps.style.width = `${value}px`;
      forceUpdate();
      parent.onChanged();
    },
    start: ((_dataProps$style = dataProps.style) === null || _dataProps$style === void 0 ? void 0 : _dataProps$style.width) === undefined ? 728 : parseInt((_dataProps$style2 = dataProps.style) === null || _dataProps$style2 === void 0 ? void 0 : _dataProps$style2.width),
    value: parseInt((_dataProps$style3 = dataProps.style) === null || _dataProps$style3 === void 0 ? void 0 : _dataProps$style3.width),
    min: 100,
    max: 728,
    step: 4
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Alignment:"), " "), /*#__PURE__*/React.createElement(Dropdown, {
    className: "mx-2"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, (_dataProps$alignment = dataProps.alignment) !== null && _dataProps$alignment !== void 0 ? _dataProps$alignment : "None"), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.alignment = "center";
      forceUpdate();
      parent.onChanged();
    }
  }, "Center"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.alignment = "left";
      forceUpdate();
      parent.onChanged();
    }
  }, "Left"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.alignment = "right";
      forceUpdate();
      parent.onChanged();
    }
  }, "Right")))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Image Credit?")), /*#__PURE__*/React.createElement(NeutralToggle, {
    style: {
      display: 'block'
    },
    optionTrue: "Yes",
    optionFalse: "No",
    value: hasCredits,
    onChange: v => {
      if (v) {
        setHasCredits(true);
        if (tempCredits !== "") {
          dataProps.photoCredit = tempCredits;
        }
      } else {
        setHasCredits(false);
        setTempCredits(dataProps.photoCredit);
        dataProps.photoCredit = undefined;
      }
      forceUpdate();
      parent.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, {
    className: `image-info-${hasCredits ? 'enable' : 'disabled'}`
  }, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Image Credit")), /*#__PURE__*/React.createElement(RichText, {
    noWrapper: true,
    value: dataProps.photoCredit,
    onChange: v => {
      dataProps.photoCredit = v;
      forceUpdate();
      parent.onChanged();
    }
  }))));
}
export function FigureInfo(props) {
  const forceUpdate = useForceUpdate();
  const parent = props;
  const dataProps = parent.data.props;
  const [hasCaption, setHasCaption] = useState(dataProps.caption !== undefined);
  const [tempCaption, setTempCaption] = useState("");
  const [captionDisplayTop, setCaptionDisplayTop] = useState(dataProps.topCaption !== undefined);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImageInfo, props), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Image Caption?")), /*#__PURE__*/React.createElement(NeutralToggle, {
    style: {
      display: 'block'
    },
    optionTrue: "Yes",
    optionFalse: "No",
    value: hasCaption,
    onChange: v => {
      if (v) {
        setHasCaption(true);
        if (tempCaption !== "") {
          if (captionDisplayTop) {
            dataProps.topCaption = tempCaption;
          } else {
            dataProps.caption = tempCaption;
          }
        }
      } else {
        setHasCaption(false);
        if (captionDisplayTop) {
          setTempCaption(dataProps.topCaption);
        } else {
          setTempCaption(dataProps.caption);
        }
        dataProps.topCaption = undefined;
        dataProps.caption = undefined;
      }
      forceUpdate();
      parent.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, {
    className: `image-info-${hasCaption ? 'enable' : 'disabled'}`
  }, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Display Caption:"), " Top or Bottom"), /*#__PURE__*/React.createElement(NeutralToggle, {
    style: {
      display: 'block'
    },
    optionTrue: "Top",
    optionFalse: "Bottom",
    value: captionDisplayTop,
    onChange: v => {
      if (v) {
        setCaptionDisplayTop(true);
        dataProps.topCaption = dataProps.caption;
      } else {
        setCaptionDisplayTop(false);
        dataProps.topCaption = undefined;
      }
      forceUpdate();
      parent.onChanged();
    }
  }), /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Caption:"), " ", /*#__PURE__*/React.createElement("i", null, "A figurative description of the image.")), /*#__PURE__*/React.createElement(RichText, {
    value: captionDisplayTop ? dataProps.topCaption : dataProps.caption,
    onChange: v => {
      if (captionDisplayTop) {
        dataProps.topCaption = v;
      } else {
        dataProps.caption = v;
      }
      forceUpdate();
      parent.onChanged();
    }
  })));
}